import { equalizer } from "../modules/equalizer";
export { lisanOksjoni };

let auctionTabs;

const lisanOksjoni = () => {

    auctionTabs = function(argument) {
        $('.' + argument).show().siblings().hide();
        $('.new-auction-list').find('li[data-auction="' + argument + '"]').addClass('active').siblings().removeClass('active');
    }

    if (MODULE_NAME === "lisa_oksjonXXX") {
        $('.add-auction-buttons .button-prev').on('click', function () {
            if ($('.add-auction-step-two').is(':visible')) {
                auctionTabs('add-auction-step-one');
            } else {
                auctionTabs('add-auction-step-two');
            }
        });
        /*
        $('.select-auction-card-svg-wrapper, .select-auction-card-header').on('click', function () {
            var $myData = $(this).data('auction-type');
            auctionTabs('add-auction-step-two');
            $('.add-auction-step-two').find('[data-auction-type="' + $myData + '"]').show().siblings().hide();
        });
        */
        $('.add-auction-buttons .button-next').on('click', function () {
            auctionTabs('add-auction-step-three');
            equalizer("auto");
        });
        $(".button-confirm-auction, .button-confirm-auction-login").on("click", function (e) {
            $(".add-auction-step-three").css({
                "pointer-events": "none",
                "opacity": ".5"
            })
            if ($(e.target).hasClass("button-confirm-auction-login")) {
                $(".cta-login").show();
            }
            if ($(e.target).hasClass("button-confirm-auction")) {
                $(".row-green").show();
            }
            $(".add-auction-step-four").show();
        });
        $(".close-cta-login").on("click", function () {
            $(".add-auction-step-three").css({
                "opacity": 1,
                "pointer-events": "auto"
            })
            $(".cta-login").hide();
        });
    }
    if (MODULE_NAME === "lisa_oksjonOLD" || MODULE_NAME === "lisa_kuulutusOLD") {
        //AUCTION TABS
        $('.add-auction-buttons .button-prev').on('click', function () {
            if ($('.add-auction-step-two').is(':visible')) {
                auctionTabs('add-auction-step-one');
            } else {
                auctionTabs('add-auction-step-two');
            }
        });
        /*
        $('.select-auction-card-svg-wrapper, .select-auction-card-header').on('click', function () {
            var $myData = $(this).data('auction-type');
            auctionTabs('add-auction-step-two');
            $('.add-auction-step-two').find('[data-auction-type="' + $myData + '"]').show().siblings().hide();
        });
        */
        $('.add-auction-buttons .button-next').on('click', function () {
            auctionTabs('add-auction-step-three');
            equalizer("auto");
        });
        $(".button-confirm-auction, .button-confirm-auction-login").on("click", function (e) {
            $(".add-auction-step-three").css({
                "pointer-events": "none",
                "opacity": ".5"
            })
            if ($(e.target).hasClass("button-confirm-auction-login")) {
                $(".cta-login").show();
            }
            if ($(e.target).hasClass("button-confirm-auction")) {
                $(".row-green").show();
            }
            $(".add-auction-step-four").show();
        });
        $(".close-cta-login").on("click", function () {
            $(".add-auction-step-three").css({
                "opacity": 1,
                "pointer-events": "auto"
            })
            $(".cta-login").hide();
        });
        $(".radio-input-trigger input").on("click", function () {
            var $this = $(this);
            var $thisName = $this.attr("name");
            var $input = $("input[name=" + $thisName + "]");
            if ($input.is(":checked")) {
                $input.parent().siblings(".radio-input-target").hide();
            }
            $this.parent().siblings(".radio-input-target").show();
        });
    }
}